import { render } from "./CompanyLookup.vue?vue&type=template&id=36c704c4&scoped=true"
import script from "./CompanyLookup.vue?vue&type=script&lang=js"
export * from "./CompanyLookup.vue?vue&type=script&lang=js"

import "./CompanyLookup.vue?vue&type=style&index=0&id=36c704c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c704c4"]])

export default __exports__